module.exports = __webpack_public_path__ + "static/img/nodata.e43799b6.png";